
import * as angular from "angular";

export class VeriDialogController {

    static $inject = [ "$mdDialog"];

    constructor(private readonly $mdDialog: angular.material.IDialogService) {
    }

    cancel(): void {
        this.$mdDialog.cancel();
    }

    hide(): void {
        this.$mdDialog.hide();
    }
}
